/**
 * ==============================================
 * メッセージカード & オーダーノート管理システム
 * ==============================================
 */

document.addEventListener("DOMContentLoaded", function () {
  // ===== 変数初期化 =====
  let userNote = "";
  let messageCardInfo = "";
  let giftPropertiesInfo = "";

  /**
   * カートデータからgiftPropertiesを再構築
   */
  function rebuildGiftProperties(cartItems) {
    window.giftProperties = {
      messageCards: [],
      wrapping: false,
    };

    cartItems.forEach((item) => {
      if (item.properties) {
        Object.keys(item.properties).forEach((key) => {
          if (key.startsWith("_")) return;

          const value = item.properties[key];

          if (key === "ギフトメッセージカードを希望する" && value) {
            window.giftProperties.messageCards.push({
              productName: item.product_title,
              value: value,
            });
          }

          if (
            key ===
              "ギフトラッピングを希望する（ 複数購入時はラッピング対象商品をカートページ備考欄へご記載ください ）" &&
            value
          ) {
            window.giftProperties.wrapping = true;
          }
        });
      }
    });
  }

  /**
   * ギフトプロパティを整形して取得
   */
  function getGiftPropertiesText() {
    if (!window.giftProperties) {
      return "";
    }

    let propertiesText = "";

    if (
      window.giftProperties.messageCards &&
      window.giftProperties.messageCards.length > 0
    ) {
      propertiesText += "以下ギフトメッセージカードの内容↓\n";
      window.giftProperties.messageCards.forEach((item) => {
        propertiesText += `${item.productName} - ギフトメッセージカードを希望する：${item.value}\n`;
      });
    }

    if (window.giftProperties.wrapping) {
      propertiesText += "以下ギフトラッピングの内容↓\n";
      propertiesText += "ギフトラッピングを希望する\n";
    }

    return propertiesText.trim();
  }

  /**
   * 全メッセージカードセレクトの選択値を結合してmessageCardInfoを更新
   */
  function buildMessageCardInfo() {
    const selects = document.querySelectorAll(".message-card-select");
    const parts = [];
    selects.forEach(function (select) {
      const cardValue = select.value;
      if (cardValue && cardValue !== "") {
        const cardName =
          select.getAttribute("data-card-name") || "メッセージカード";
        parts.push(cardName + "：" + cardValue);
      }
    });
    messageCardInfo = parts.join("\n");
  }

  /**
   * 初期化関数
   */
  function initializeNotes() {
    const userVisibleTextarea = document.getElementById("user-visible-note");
    const hiddenNoteInput = document.getElementById("cart-note");

    if (userVisibleTextarea && hiddenNoteInput) {
      const fullNote = hiddenNoteInput.value;

      let cleanedNote = fullNote;

      if (cleanedNote.includes("以下メッセージカードの内容↓")) {
        cleanedNote = cleanedNote
          .split("以下メッセージカードの内容↓")[0]
          .trim();
      }
      if (cleanedNote.includes("以下ギフトメッセージカードの内容↓")) {
        cleanedNote = cleanedNote
          .split("以下ギフトメッセージカードの内容↓")[0]
          .trim();
      }
      if (cleanedNote.includes("以下ギフトラッピングの内容↓")) {
        cleanedNote = cleanedNote
          .split("以下ギフトラッピングの内容↓")[0]
          .trim();
      }

      const lines = cleanedNote.split("\n");
      const filteredLines = lines.filter((line) => {
        return (
          !line.match(/^[^：]+：.+$/) &&
          !line.match(/^.+ - ギフトメッセージカードを希望する：.+$/) &&
          line !== "ギフトラッピングを希望する"
        );
      });
      cleanedNote = filteredLines.join("\n").trim();

      userNote = cleanedNote;
      buildMessageCardInfo();
      giftPropertiesInfo = getGiftPropertiesText();

      userVisibleTextarea.value = userNote;
      updateOrderNote();
    }
  }

  /**
   * order.note更新関数
   */
  function updateOrderNote() {
    const hiddenNoteInput = document.getElementById("cart-note");
    if (!hiddenNoteInput) return;

    let finalNote = userNote;

    if (messageCardInfo) {
      finalNote += (userNote ? "\n" : "") + messageCardInfo;
    }

    if (giftPropertiesInfo) {
      finalNote += (finalNote ? "\n" : "") + giftPropertiesInfo;
    }

    hiddenNoteInput.value = finalNote;

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note: finalNote,
      }),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error("Cart update failed:", error);
      });
  }

  /**
   * メッセージカード選択監視（複数セレクト対応）
   */
  document.querySelectorAll(".message-card-select").forEach(function (select) {
    select.addEventListener("change", function () {
      buildMessageCardInfo();
      updateOrderNote();
    });
  });

  /**
   * ユーザー表示用メモ欄の監視
   */
  const userVisibleTextarea = document.getElementById("user-visible-note");
  if (userVisibleTextarea) {
    userVisibleTextarea.addEventListener("input", function () {
      userNote = this.value;
      updateOrderNote();
    });

    userVisibleTextarea.addEventListener("blur", function () {
      updateOrderNote();
    });

    userVisibleTextarea.addEventListener("paste", function () {
      setTimeout(() => {
        const messageCardPattern = /\n([^：\n]+：[^\n]+)$/;
        if (
          this.value.includes("以下メッセージカードの内容↓") ||
          this.value.includes("以下ギフトメッセージカードの内容↓") ||
          this.value.includes("以下ギフトラッピングの内容↓") ||
          messageCardPattern.test(this.value)
        ) {
          let cleanContent = this.value
            .split("以下メッセージカードの内容↓")[0]
            .split("以下ギフトメッセージカードの内容↓")[0]
            .split("以下ギフトラッピングの内容↓")[0]
            .replace(messageCardPattern, "")
            .trim();
          this.value = cleanContent;
          userNote = cleanContent;
          updateOrderNote();
        }
      }, 100);
    });
  }

  /**
   * カート変更時にプロパティを再取得
   */
  document.addEventListener("cart:updated", function () {
    giftPropertiesInfo = getGiftPropertiesText();
    updateOrderNote();
  });

  /**
   * 削除ボタンの監視
   */
  document.addEventListener("click", function (e) {
    const deleteLink = e.target.closest('a[href*="/cart/change"]');

    if (deleteLink && deleteLink.href.includes("quantity=0")) {
      e.preventDefault();

      const url = deleteLink.href;
      const lineItem = deleteLink.closest("li");

      fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (lineItem) {
            lineItem.remove();
          }

          rebuildGiftProperties(data.items);
          giftPropertiesInfo = getGiftPropertiesText();
          updateOrderNote();

          if (data.item_count === 0) {
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("削除エラー:", error);
          window.location.reload();
        });
    }
  });

  /**
   * 数量セレクターで0になったときの処理
   */
  document.addEventListener("change", function (e) {
    const quantityInput = e.target;

    if (
      quantityInput &&
      quantityInput.type === "number" &&
      quantityInput.name === "updates[]"
    ) {
      const newValue = parseInt(quantityInput.value, 10);

      if (newValue === 0 || isNaN(newValue)) {
        setTimeout(() => {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              rebuildGiftProperties(data.items);
              giftPropertiesInfo = getGiftPropertiesText();
              updateOrderNote();

              if (data.item_count === 0) {
                window.location.reload();
              }
            });
        }, 500);
      }
    }
  });

  /**
   * マイナスボタンで0になる場合の処理
   */
  document.addEventListener("click", function (e) {
    const minusButton = e.target.closest('button[name="minus"]');

    if (minusButton) {
      const quantitySelector = minusButton.closest("quantity-selector");
      if (quantitySelector) {
        const input = quantitySelector.querySelector('input[type="number"]');

        if (input) {
          const currentValue = parseInt(input.value, 10);

          if (currentValue === 1) {
            setTimeout(() => {
              fetch("/cart.js")
                .then((response) => response.json())
                .then((data) => {
                  rebuildGiftProperties(data.items);
                  giftPropertiesInfo = getGiftPropertiesText();
                  updateOrderNote();

                  if (data.item_count === 0) {
                    window.location.reload();
                  }
                });
            }, 500);
          }
        }
      }
    }
  });

  // ===== 初期化実行 =====
  initializeNotes();
});
